<template>
  <div class="container-list">
    <ul class="tab-wrap" v-if="!$route.query.index && $route.query.index !== 0">
      <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index, tab)" v-for="(tab, index) in tabList">
        {{ tab }}
      </li>
    </ul>
    <div class="flex">
      <unitList
        v-show="$store.state.user.company.cCompanyNum === 'aaa'"
        @select="getUnit"
        @getFirst="getOne"
        :isbim="nowIndex == 8 || nowIndex === 9 ? true : false"
      ></unitList>
      <div class="flex1">
        <company v-if="nowIndex == 0"></company>

        <jiejingList v-if="nowIndex == 1"></jiejingList>

        <jiejingdtList v-if="nowIndex == 2"></jiejingdtList>
        <jiejingstatic v-if="nowIndex == 3"> </jiejingstatic>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";
import jiejingList from "./jiejingList.vue";
import jiejingdtList from "./jiejingdtList.vue";
import company from "./companyList.vue";
import jiejingstatic from "./static.vue";
// import tab2 from "./tab2.vue";
// import tab3 from "./tab3.vue";
// import tab4 from "./tab4.vue";
// import tab5 from "./tab5.vue";
// import tab6 from "./tab6.vue";
// import tab7 from "./tab7.vue";
// import tab8 from "./tab8.vue";
// import tab9 from "./tab9.vue";
// import tab10 from "./tab10.vue";

export default {
  components: {
    unitList,
    jiejingList,
    jiejingdtList,
    company,
    jiejingstatic,
  },
  data() {
    return {
      nowIndex: this.$route.query.index || 0,
      cpNum: "",
      nowid: "",
      tabList: ["所辖单位列表", "上报单位列表", "已处理火警单位列表", "数据统计"],
      company: "",
    };
  },
  created() {
    this.getOne();
    if (this.$route.query.index == 0) {
      this.nowIndex = 8;
    }
  },
  mounted() {},
  methods: {
    changeTab(index, it) {
      this.nowIndex = index;
      this.nowid = it.tr_role_key;
    },
    getOne(val) {
      this.cpNum = val;
    },
    getUnit(val) {
      this.cpNum = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  margin-left: 60px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
